import { type } from 'arktype';
import { utcInstantSchema } from './utc-instant.model';

export const clockInSchema = type({
  'startTime?': utcInstantSchema,
  'homeOffice?': 'boolean',
  'note?': 'string | null',
});
export type ClockInInput = typeof clockInSchema.t;

/** Direction of a stamp event. */
export type ClockStampType = 'in' | 'out';

/** The last stamp of the person — powers the button tooltip (anti double-stamp aid). */
export interface ClockLastStamp {
  type: ClockStampType;
  /** ISO timestamp of the stamp (server time). */
  at: string;
}

/**
 * State of the web quick-stamp (F12): whether an open stamp exists and what
 * the person's last stamp was. An open stamp is a `booking_records` row with
 * `endTime null` + `metadata.openStamp = true` — no dedicated table.
 */
export interface ClockState {
  isClockedIn: boolean;
  /** Present while clocked in. */
  openStamp: {
    bookingId: string;
    /** ISO timestamp of the clock-in (server time). */
    startedAt: string;
  } | null;
  lastStamp: ClockLastStamp | null;
}
